var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "promotions-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg promotions",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "promotions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6,6.6a1.39,1.39,0,0,1,0,1.9L18.9,21.1a1.39,1.39,0,0,1-1.9,0l-5.7-5.7L2.2,24.5a1.39,1.39,0,0,1-1.9,0,1.39,1.39,0,0,1,0-1.9l10-10a1.39,1.39,0,0,1,1.9,0l5.7,5.7L29.7,6.6A1.23,1.23,0,0,1,31.6,6.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3,7.5a1.32,1.32,0,0,1,1.3-1.3h8a1.32,1.32,0,0,1,1.3,1.3v8a1.3,1.3,0,0,1-2.6,0V8.8H22.6A1.32,1.32,0,0,1,21.3,7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.a32597741f26549e10a2264d330d19fc.svg";
export { ForwardRef as ReactComponent };